import React, {useCallback} from 'react';
import {timeStampToTimeShortFormat, betMoney} from 'app/utils';
import {size190x190} from 'app/utils/CasinoGameImages';
import {startCasinoGame} from 'app/services/CasinoServices';

interface Props {
    game_id: number
    name?: string
    amount?: string
    created_at?: number
    bet_amount?: string
    provider_name: string
    identifier: string
    withDescription?: boolean
    released_at?: number | null
    in_out?: boolean
    image_url?: string | null
}

const AccordionItem: React.FC<Props> = props => {
    const startCasino = () => {
        startCasinoGame(props.game_id);
    };

    const handleStartCasino = useCallback(() => startCasino(), [startCasino]);

    return <div className="accordion-item">
        <div className="image">
            <button className="button-image" onClick={handleStartCasino}>
                <img className="image-img"
                    src={size190x190(
                        props.provider_name,
                        props.identifier,
                        props.released_at,
                        props.in_out,
                        props.image_url
                    )}
                    alt="Teen Patti"/>
            </button>
        </div>
        {props.withDescription && <div className="description">
            <div className="information information-date">
                <span className="name">{props.name}</span>
                <span className="date">{timeStampToTimeShortFormat(props.created_at)}</span>
            </div>
            <div className="information information-amount">
                <span className="amount">{betMoney({amount: props.bet_amount})}</span>
                <span className="arrow">&gt;</span>
                <span className="amount">{betMoney({amount: props.amount})}</span>
            </div>
        </div>}
    </div>;
};

export default AccordionItem;
